import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Source, Layer } from 'react-mapbox-gl'
import ChartActions from '../redux/chartRedux'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
// import BuoyImage from '../assets/simpleBuoy.svg'
import { svg } from '../assets/buoySprite'
import Popup, { SimpleDialogWrapped } from './Popup'
import postData from '../utility/postData'

// const layoutLayer = { 'icon-image': 'londonCycle' }
const image = new Image()
image.src = 'data:image/svg+xml;charset=utf-8,' + svg
// const images = ['londonCycle', image]

export const BUOYS = (token, email) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ASmartIceFeatures&email=${email}&token=${token}`

const id = 'SmartIceFeatures'
const authId = 'SmartIce'
const sourceLayer = 'SmartIceFeatures'

class Buoys extends Component {
  static contextTypes = {
    map: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.state = {
      popup: false,
      feature: null
    }
  }

  handlePopupClose = () => {
    this.setState({ popup: false })
  }

  handlePopupClick = ({ type, featureId }) => {
    const { map } = this.context
    switch (type) {
    case 'REMOVE':
      postData(`https://feathers.looknorthservices.com/features/${featureId}`, {}, 'DELETE')
        .then(data => console.log(JSON.stringify(data))) // JSON-string from `response.json()` call
        .then(() => {
          const source = map.getSource(id)
          const sourceUrl = source._data
          source.setData(sourceUrl)
          this.handlePopupClose()
        })
        .catch(error => console.error(error));

      break
    default:
      console.log('handleClick type not found')
    }
  }

    componentDidMount () {
      const { map } = this.context
      if (!map) { return }
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('click', id, this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('click', id, this.handleClick)
  }

  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context

    map.getCanvas().style.cursor = ''
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const { features } = event
    if (features && features.length > 0) {
      const feature = features[0]

      this.setState({ popup: true, feature })
      // actions.streetviewAdded(event.lngLat)
    }
  }
  render () {
    const { idToken, layerRendered, paint, email } = this.props
    const { popup, feature } = this.state

    const visible = layerRendered

    if (!visible) {
      return null
    }

    return (
      <Fragment>
        <SimpleDialogWrapped
          selectedValue='username@gmail.com'
          open={popup}
          onClose={this.handlePopupClose}
          feature={feature}
          handleClick={this.handlePopupClick}
          />
        <Source
          id={id}
          geoJsonSource={{
            type: 'geojson',
            data: BUOYS(idToken, email)
          }}
        />
        <Layer
          type='circle'
          id={id}
          sourceId={id}
          paint={paint}
          filter={['==', 'email', email]}
          // layout={layoutLayer}
          // images={images}
        />
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      email: state.login.roles.name,
      login: state.login,
      roles: state.login.roles,
      idToken: state.login.idToken,
      layersRendered: state.layer.layersRendered,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      chartPanelToggled: () => dispatch(ChartActions.chartPanelToggled())
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(Buoys)



// WEBPACK FOOTER //
// ./src/layers/SmartIceFeatures.js